/* @flow */
import React, { Component } from 'react';

import ActivityCreateDialogContainer from 'payments/containers/ActivityCreateDialogContainer.jsx';
import Avatar from 'components/Avatar.jsx';
import Hovercard from 'components/Hovercard.jsx';
import Link from 'components/Link.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import UniversalComposer, { PANELS } from 'chat/components/UniversalComposer.jsx';
import User from 'entities/User';

import './styles/UniversalComposeHovercard.scss';

type Props = {
  currentUser: User,
  hideAnnouncements?: ?bool,
  hideActivities?: ?bool,
  onMessageSent?: ?Function,
  onComposeSelection?: ?Function,
};

export default class UniversalComposeHovercard extends Component {
  props: Props;

  getUniversalComposerForPanel(panel: number) {
    const canAnnounce = this.props.currentUser.canCreateGroups();
    return <UniversalComposer canAnnounce={canAnnounce} panel={panel} onMessageSent={this.props.onMessageSent} />;
  }

  render() {
    const { currentUser, hideAnnouncements, hideActivities, onComposeSelection } = this.props;

    const canComposeAnnouncements = !hideAnnouncements && currentUser.canComposeAnnouncements();
    const canComposeGroupChat = currentUser.canComposeGroupChat();
    const canComposeActivity = !hideActivities && currentUser.canCreateActivity();
    const canComposeIndividualChat = currentUser.canComposeIndividualChat();
    const eventScreenName = 'universal_composer_hovercard';

    return (
      <Hovercard {...this.props} className="UniversalComposeHovercard">
        {canComposeAnnouncements &&
          <ModalTrigger modal={this.getUniversalComposerForPanel(PANELS.CLASS_ANNOUCEMENT)}>
            <div className="UniversalComposeHovercard-item" onClick={onComposeSelection}>
              <Avatar glyphName="megaphone" color="brand" size="small" />
              <Link
                className="UniversalComposeHovercard-item-link"
                eventElementName="class_announcement"
                eventScreenName={eventScreenName}
                color="inherit">
                Class announcement
              </Link>
            </div>
          </ModalTrigger>
        }

        {canComposeGroupChat &&
          <ModalTrigger modal={this.getUniversalComposerForPanel(PANELS.GROUP_CONVERSATION)}>
            <div className="UniversalComposeHovercard-item" onClick={onComposeSelection}>
              <Avatar glyphName="avatar-group-stroke" color="brand" size="small" />
              <Link
                data-test-selector="group_conversation_menu_item"
                className="UniversalComposeHovercard-item-link"
                eventElementName="group_conversation"
                eventScreenName={eventScreenName}
                color="inherit">
                Group conversation
              </Link>
            </div>
          </ModalTrigger>
        }

        {canComposeIndividualChat &&
          <ModalTrigger modal={this.getUniversalComposerForPanel(PANELS.INDIVIDUAL_MESSAGE)}>
            <div className="UniversalComposeHovercard-item" onClick={onComposeSelection}>
              <Avatar glyphName="message-individual" color="brand" size="small" />
              <Link
                className="UniversalComposeHovercard-item-link"
                eventElementName="individual_message"
                eventScreenName={eventScreenName}
                color="inherit">
                Individual message
              </Link>
            </div>
          </ModalTrigger>
        }

        {canComposeActivity &&
          <ModalTrigger modal={<ActivityCreateDialogContainer />}>
            <div className="UniversalComposeHovercard-item" onClick={onComposeSelection}>
              <Avatar glyphName="calendar-stroke" color="brand" size="small" />
              <Link
                className="UniversalComposeHovercard-item-link"
                eventElementName="new_activity"
                eventScreenName={eventScreenName}
                color="inherit">
                Activity
              </Link>
            </div>
          </ModalTrigger>
        }
      </Hovercard>
    );
  }
}



// WEBPACK FOOTER //
// ./src/chat/components/UniversalComposeHovercard.jsx